import React, { useState, useEffect } from "react";
import { FaEdit, FaArrowLeft, FaBox, FaPlus, FaCheck, FaTimes, FaToggleOn, FaToggleOff, FaMapMarkerAlt
  , FaPhone, FaCode
 } from "react-icons/fa";
import { RiHomeOfficeFill } from "react-icons/ri";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { getProvinceName } from "../../../utils/Common";
import SelectSearch from "../SelectSearch";
import Spinner from "../../Spinner";
import "./index.css";

const OfficeDetails = ({ office, onClose, onAddCaja, onUpdateOffice, onStatusOffice, onStatusCaja, onUpdateCaja, isActive, provinces }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [newCajaName, setNewCajaName] = useState("");
  const [isLoadingAddCaja, setIsLoadingAddCaja] = useState(false);
  const [isLoadingUpdateOffice, setIsLoadingUpdateOffice] = useState(false);
  const [isLoadingUpdateCaja, setIsLoadingUpdateCaja] = useState(false);
  const [isLoadingToggleStatus, setIsLoadingToggleStatus] = useState(false);
  const [isEditingOffice, setIsEditingOffice] = useState(false);
  const [isEditingCaja, setIsEditingCaja] = useState(null);
  const [editedOffice, setEditedOffice] = useState({ ...office });
  const [editedCaja, setEditedCaja] = useState({});
  const [isOfficeActive, setIsOfficeActive] = useState(isActive);
  const [isOfficeModified, setIsOfficeModified] = useState(false);
  const [isCajaModified, setIsCajaModified] = useState(false);
  const [provinceSelected, setProvinceSelected] = useState(office.IdProvincia);

  useEffect(() => {
    setIsOfficeModified(
      editedOffice.NombreSucursal !== office.NombreSucursal ||
      editedOffice.Codigo !== office.Codigo ||
      editedOffice.Direccion !== office.Direccion ||
      editedOffice.Telefono !== office.Telefono ||
      provinceSelected !== office.IdProvincia
    );
  }, [editedOffice, office, provinceSelected]);

  useEffect(() => {
    if (isEditingCaja !== null) {
      const originalCaja = office.cashBoxes.find(c => c.IdCaja === isEditingCaja);
      setIsCajaModified(
        editedCaja.NombreCaja !== originalCaja.NombreCaja
      );
    }
  }, [editedCaja, isEditingCaja, office.cashBoxes]);

  const handleAddCaja = async () => {
    if (newCajaName.trim()) {
      setIsLoadingAddCaja(true);
      await onAddCaja(newCajaName);
      setNewCajaName("");
      setIsCreating(false);
      setIsLoadingAddCaja(false);
    }
  };

  const handleUpdateOffice = async () => {
    setIsLoadingUpdateOffice(true);
    await onUpdateOffice(editedOffice, provinceSelected);
    setIsEditingOffice(false);
    setIsLoadingUpdateOffice(false);
  };

  const handleUpdateCaja = async (EditCaja, action, caja) => {
    setIsLoadingUpdateCaja(true);
    await onUpdateCaja(EditCaja, action, caja);
        const updatedCashBoxes = office.cashBoxes.map((cb) =>
          cb.IdCaja === caja.IdCaja ? { ...cb, NombreCaja: EditCaja.NombreCaja } : cb
        );
        office.cashBoxes = updatedCashBoxes;
    setIsEditingCaja(null); 
    setIsLoadingUpdateCaja(false);
  };

  const handleToggleCajaStatus = async (caja) => {
    setIsLoadingUpdateCaja(true);
    const newStatus = caja.IsActive === 1 ? 2 : 3;
    try {
      const response = await onStatusCaja(caja, newStatus);
        const updatedCashBoxes = office.cashBoxes.map((cb) =>
          cb.IdCaja === caja.IdCaja ? { ...cb, IsActive: response.payload?.NuevoEstado } : cb
        );
        office.cashBoxes = updatedCashBoxes; 
      setIsLoadingUpdateCaja(false);
    } catch (error) {
      setIsLoadingUpdateCaja(false);
    }
  };

  const handleToggleOfficeStatus = async () => {
    setIsLoadingToggleStatus(true);
    const newStatus = !isOfficeActive;
    try {
      const response = await onStatusOffice(office, newStatus);
      setIsOfficeActive(response.payload?.NuevoEstado === 1 ? true : false);
      setIsLoadingToggleStatus(false);
    } catch (error) {
      setIsLoadingToggleStatus(false);
    }
  };

  const handleSelect = (name, value) => {
    if (name === "Province") {
      setProvinceSelected(value);
    }
  };

  const renderInput = (icon, label, value, onChange, error = null, required = false) => (
    <div className="col-md-6 mb-4 text-left">
        <label className="form-label elegant-label">
          <span className="input-icon elegant-icon">{icon}</span>
            <span className="label-text">
              {label}
              {required && <span className="text-danger">*</span>}
            </span>
          </label>
          {isEditingOffice ? (
            <div className="elegant-input-container">
              <input
                type="text"
                className={`elegant-input ${error ? 'is-invalid' : ''}`}
                value={value}
                onChange={onChange}
                aria-label={label}
              />
              {error && <div className="elegant-error-message">{error}</div>}
            </div>
          ) : (
            <div className="elegant-display-value">
              <div className="display-content">
                {value || <span className="empty-value">No especificado</span>}
              </div>
              <div className="display-border"></div>
            </div>
          )}
    </div>
  );

const renderSelectInput = (icon, label, options, value, onChange, error = null, required = false) => {
  return (
    <div className="col-md-6 mb-4 text-left">
      <div className="form-group elegant-form-group">
        <label className="form-label elegant-label">
          <span className="input-icon elegant-icon">{icon}</span>
          <span className="label-text">
            {label}
            {required && <span className="text-danger">*</span>}
          </span>
        </label>

        {isEditingOffice ? (
          <div className="elegant-select-container mt-3">
            <SelectSearch
              options={options}
              nameInput={"Province"}
              setValue={handleSelect}
              value={value} 
              onChange={onChange}
              placeholder="Seleccionar provincia"
              className={`elegant-select ${error ? 'is-invalid' : ''}`}
              />
            {error && <div className="elegant-error-message">{error}</div>}
          </div>
        ) : (
          <div className="elegant-display-value">
            <div className="display-content">
              {getProvinceName(value) || <span className="empty-value">No especificado</span>}
            </div>
            <div className="display-border"></div>
          </div>
        )}
      </div>
    </div>
  );
};

  return (
    <>
      <div className="dashboardCard text-left" style={{ background: "linear-gradient(135deg,rgb(192, 0, 0) 20%, #1E3C72 20%)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
          <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
            <RiHomeOfficeFill size={20} className="mr-1" color="white" />
            <h5 className="mb-0" style={{ color: "white" }}>{office.NombreSucursal}</h5>
          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <button type="button" className="btn btn-dark y d-flex align-items-center" onClick={onClose}>
              <FaArrowLeft className="mr-2" /> Regresar
            </button>
            {isEditingOffice ? (
              <>
                <button className="btn btn-success d-flex align-items-center" onClick={handleUpdateOffice} disabled={!isOfficeModified || isLoadingUpdateOffice}>
                  {isLoadingUpdateOffice ? <Spinner type={2} className="mr-2" /> : <FaCheck className="mr-2" /> } Guardar
                </button>
                <button className="btn btn-warning d-flex align-items-center" 
                onClick={() => { 
                  setIsEditingOffice(false); 
                  setEditedOffice({ ...office });
                  setProvinceSelected(office.IdProvincia);
                
                }}
                   style={{ color: "black" }} disabled={isLoadingUpdateOffice}>
                  <FaTimes className="mr-2" /> Cancelar
                </button>
              </>
            ) : (
              <button className="btn btn-warning d-flex align-items-center" onClick={() => setIsEditingOffice(true)} style={{ color: "black" }} disabled={isLoadingUpdateOffice}>
                <FaEdit className="mr-2" /> Editar
              </button>
            )}
            <button className="btn btn-info d-flex align-items-center" onClick={handleToggleOfficeStatus} disabled={isLoadingToggleStatus}>
              {isLoadingToggleStatus ? <Spinner type={2} className="mr-2"/> : (isOfficeActive ? <FaToggleOn className="mr-2" /> : <FaToggleOff className="mr-2" />)}
              {isOfficeActive ? "Desactivar" : "Activar"}
            </button>
          </div>
        </div>
      </div>
      <div className="dashboardCard" style={{ color: "black" }}>
        <div className="office-details-content">
          <div className="mb-3 border-bottom pb-3">
            <h5 className="text-dark text-uppercase fw-bold">Información de la Estafeta</h5>
          </div>
          <div className="row g-3"  style={{fontSize: "20px"}}>
              {renderSelectInput(<RiHomeOfficeFill size={20} />, "Provincia de la Estafeta", provinces, provinceSelected, (e) => setEditedOffice({ ...editedOffice, NombreProvincia: e.target.value }))}
              {renderInput(<RiHomeOfficeFill size={20} />, "Nombre de la Estafeta", editedOffice.NombreSucursal, (e) => setEditedOffice({ ...editedOffice, NombreSucursal: e.target.value }))}
              {renderInput(<FaCode size={20} />, "Código de la Estafeta", editedOffice.Codigo, (e) => setEditedOffice({ ...editedOffice, Codigo: e.target.value }))}
              {renderInput(<FaMapMarkerAlt size={20} />, "Dirección", editedOffice.Direccion, (e) => setEditedOffice({ ...editedOffice, Direccion: e.target.value }))}
              {renderInput(<FaPhone size={20} />, "Teléfono", editedOffice.Telefono, (e) => setEditedOffice({ ...editedOffice, Telefono: e.target.value }))}
          </div>
        </div>
      </div>

      <div className="dashboardCard" style={{ color: "black" }}>
        <div className="mb-3 border-bottom pb-3">
          <h5 className="text-dark text-uppercase fw-bold">Cajas de Estafeta</h5>
        </div>
        <TransitionGroup className="row row-cols-1 row-cols-md-3 g-4">
          {office.cashBoxes.map((caja) => (
            <CSSTransition key={caja.IdCaja} timeout={500} classNames="fade">
              <div className="col mt-2">
                <div className="card shadow-sm" style={{ background: "#FBD825" }}>
                  <div className="card-body" style={{ padding: "0.5rem" }}>
                    <div className="d-flex align-items-center mb-3">
                      <FaBox size={20} className="mr-2" />
                      {isEditingCaja === caja.IdCaja ? (
                        <input
                          type="text"
                          className="form-control"
                          value={editedCaja.NombreCaja}
                          onChange={(e) => setEditedCaja({ ...editedCaja, NombreCaja: e.target.value })}
                        />
                      ) : (
                        <h5 className="card-title mb-0">{caja.NombreCaja}</h5>
                      )}
                      {isEditingCaja === caja.IdCaja ? (
                        <>
                          <button className="btn btn-success d-flex align-items-center ml-2" onClick={() => handleUpdateCaja(editedCaja, 1, caja)} style={{ marginLeft: "auto" }} disabled={!isCajaModified || isLoadingUpdateCaja}>
                            {isLoadingUpdateCaja ? <Spinner type={2}/> : <FaCheck size={15} />}
                          </button>
                          <button className="btn btn-warning d-flex align-items-center" onClick={() => setIsEditingCaja(null)} style={{ color: "white", marginLeft: "10px", background: "#1E3C72" }} disabled={isLoadingUpdateCaja}>
                            <FaTimes size={15} />
                          </button>
                        </>
                      ) : (
                        <>
                          <button className="btn d-flex align-items-center" onClick={() => { setIsEditingCaja(caja.IdCaja); setEditedCaja(caja); }} style={{ color: "white", marginLeft: "auto", background: "#1E3C72" }} disabled={isLoadingUpdateCaja}>
                            <FaEdit size={15} />
                          </button>
                          <button className="btn btn-info d-flex align-items-center" onClick={() => handleToggleCajaStatus(caja)} style={{ marginLeft: "10px" }} disabled={isLoadingUpdateCaja}>
                            {isLoadingUpdateCaja }
                            {caja.IsActive === 1 ? <FaToggleOn size={15} /> : <FaToggleOff size={15} />}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </CSSTransition>
          ))}

          <CSSTransition key="create-new" timeout={500} classNames="fade">
            <div className="col mt-2" onClick={() => !isCreating && setIsCreating(true)} style={{ cursor: "pointer" }}>
              <div className="card h-100 shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>
                {isCreating ? (
                  <div className="card-body d-flex flex-column justify-content-center align-items-center">
                    {isLoadingAddCaja ? (
                      <Spinner type={2}/>
                    ) : (
                      <>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Nombre de la caja"
                          value={newCajaName}
                          onChange={(e) => setNewCajaName(e.target.value)}
                          autoFocus
                        />
                        <div className="d-flex" style={{ gap: 10 }}>
                          <button
                            className="btn btn-blue btn-sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddCaja();
                            }}
                            disabled={isLoadingAddCaja}
                          >
                            {isLoadingAddCaja ? <Spinner type={2} className="mr-2" /> : <FaCheck />} Agregar
                          </button>
                          <button
                            className="btn btn-warning btn-sm"
                            style={{ color: "black" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsCreating(false);
                              setNewCajaName("");
                            }}
                            disabled={isLoadingAddCaja}
                          >
                            <FaTimes /> Cancelar
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="card-body d-flex flex-column justify-content-center align-items-center">
                    <FaPlus size={30} color="#6c757d" />
                    <h5 className="mt-2 mb-0 text-secondary">Crear Caja</h5>
                  </div>
                )}
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </div>
    </>
  );
};

export default OfficeDetails;